<template>
  <double
    :name="name"
    :options="options"
    :size_1="size_1"
    :size_2="size_2"
    :value="value"
  >
    <template #buttons>
      <slot name="buttons"></slot>
    </template>
  </double>
</template>

<script>
import merge from "rfuncs/functions/merge"
import object_map from "rfuncs/functions/object_map"

import autocomplete from "../constants/autocomplete"
import double from "./double"

export default {
  components: { double },
  props: ["name", "value", "autocomplete", "extra", "size_1", "size_2"],
  computed: {
    options() {
      const content = autocomplete[this.autocomplete]

      if (content) {
        return merge({}, this.extra || {}, {
          [content.title || ""]: object_map(
            c => c.name,
            c => c.objects,
            content.objects
          ),
        })
      }
      return this.extra || {}
    },
  },
}
</script>
